/* istanbul ignore file */

export const USER_CONSTANTS = {
    DELETED_USER_ID: 'deleted-user',
    DELETED_USER_NAME: 'This user was deleted',
};
